
import {defer as observableDefer, Observable} from 'rxjs';
import {map, publishReplay, refCount, take} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ServiceBase} from './service-base';
import {AuthHttpService} from '../auth/auth-http.service';
import {IRoleModel} from './interfaces/role.interface';
import {ISelectItemModel} from './interfaces/select-item.interface';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class RoleService extends ServiceBase {
  private static ApiUrl = 'api/role';
  private data$: Observable<ISelectItemModel[]>;

  constructor(private http: HttpClient) {
    super();
  }

  public get(): Observable<IRoleModel[]> {
    return this.http.get<IRoleModel[]>(RoleService.ApiUrl);
  }

  public getSelectItems(): Observable<ISelectItemModel[]> {
    if (!this.data$) {
      const url = RoleService.ApiUrl + '/list';

      this.data$ = observableDefer(() => this.http.get(url)).pipe(
        map((res: Response) => (res || []) as ISelectItemModel[]),
        publishReplay(1),
        refCount(),
        take(1)
      );
    }

    return this.data$;
  }
}
